import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  async connect() {
    this.currentLanguageCode = document.documentElement.lang.split('-')[0];
    this.content = this.element.querySelector('.message-rows');
    await this.load();
    this.intervalID = setInterval(() => this.load(), 60000);
  }

  async mark(event) {
    const target = event.currentTarget;

    if (target.classList.contains('messages-marking-loading')) {
      return;
    }

    target.classList.add('messages-marking-loading');

    const toMark = [];

    for (const element of target.querySelectorAll('[data-mark-read]')) {
      toMark.push(element.dataset.markRead);
    }

    if (toMark.length) {
      const url = event.currentTarget.dataset.source + '?rest_language=' + this.currentLanguageCode;

      try {
        const response = (await axios.post(url, { 'mark': toMark })).data.data;

        const el = document.getElementById('profile-unread-badge');
        const el2 = document.getElementById('profile-unread-badge-2');

        if (el) {
          if (response.unread > 0) {
            el.classList.remove('d-none-important');
            el.innerHTML = response.unread;
          } else {
            el.classList.add('d-none-important');
          }
        }

        if (el2) {
          if (response.unread > 0) {
            el2.classList.remove('d-none-important');
            el2.innerHTML = response.unread;
          } else {
            el2.classList.add('d-none-important');
          }
        }
      } catch (error) {
        console.error(error);
      }
    }

    for (const element of target.querySelectorAll('[data-mark-read]')) {
      element.removeAttribute('data-mark-read');
    }

    target.querySelector('.profile-unread-messages-badge').classList.add('d-none-important');

    target.classList.remove('messages-marking-loading');
  }

  async load() {
    if (this.element.classList.contains('messages-loading')) {
      return;
    }

    console.log('Loading messages');

    this.element.classList.add('messages-loading');

    const expandedValues = [];
    for (const element of this.element.querySelectorAll('.info-item.trigger-expanded')) {
      expandedValues.push(element.dataset.conversationKey);
    }

    try {
      const response = (await axios.get(this.element.dataset.source, {
        params: {
          rest_language: this.currentLanguageCode,
          expanded: expandedValues,
        }
      })).data.data;
      this.content.innerHTML = response.content;

      const el = document.getElementById('profile-unread-badge');
      const el2 = document.getElementById('profile-unread-badge-2');

      if (el) {
        if (response.unread > 0) {
          el.classList.remove('d-none-important');
          el.innerHTML = response.unread;
        } else {
          el.classList.add('d-none-important');
        }
      }

      if (el2) {
        if (response.unread > 0) {
          el2.classList.remove('d-none-important');
          el2.innerHTML = response.unread;
        } else {
          el2.classList.add('d-none-important');
        }
      }
    } catch (error) {
      console.error(error);
    }

    this.element.classList.remove('messages-loading');
  }

  disconnect() {
    clearInterval(this.intervalID);
    super.disconnect();
  }
}
